import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

// Create the entity card extension for KubeSecretsCard
const kubeSecretsEntityCard = EntityCardBlueprint.make({
  name: 'kube-secrets',
  params: {
    type: 'content',
    filter: {
      'metadata.annotations.backstage.io/kubernetes-namespace': {
        $exists: true,
      },
    },
    loader: async () => {
      const { KubeSecretsCard } = await import('./KubeSecretsCard');
      return <KubeSecretsCard />;
    },
  },
});

// Export as a catalog plugin extension module, not a standalone plugin
export default createFrontendModule({
  pluginId: 'catalog',
  extensions: [kubeSecretsEntityCard],
});
